import KendoChartMixin from './KendoChartMixin'

export default {
    name: 'kendo-chart',
    mixins: [ KendoChartMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChart/index.js